module.exports = __webpack_public_path__ + "img/caro-2.32388d25.jpg";